import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Sæt på et kald, hvis kaldstedet selv viser API'ets begrundelse — så `AuthInterceptor` lader være
 * med at vise den samme sætning i en snackbar oveni.
 *
 * Kurven er det typiske sted: den skriver begrundelsen på linjen eller under knappen, hvor tiderne
 * kan rettes, og en snackbar med præcis samme tekst er da støj, ikke hjælp.
 */
export const SKIP_ERROR_SNACKBAR = new HttpContextToken<boolean>(() => false);

/** Genvej til `{ context: skipErrorSnackbar() }` på et HttpClient-kald. */
export function skipErrorSnackbar(): HttpContext {
  return new HttpContext().set(SKIP_ERROR_SNACKBAR, true);
}
